import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
//import apiService from '../services/apiservices'
//import { productUpdateStockTableReady} from '../redux/products_stocks'


//import * as Constants from '../../../common/constants'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/productsStocksTable.css'

class CollapsibleRow extends Component {
    constructor() {
        super()
        this.state = {
        }
        this.dialog = null
    }
    

     checkBoxChangeUpdate = (row,e,rowIndex) => {

        let prodStocksData=this.props.row.store_kits.slice();
           
             prodStocksData.map(function(item) {
                if(item.store_kit_id===row.store_kit_id){
                    item['checked']=e.target.checked
                    return true;
                }
                return true;
            });

             this.setState({
                productStocksData:prodStocksData
             })
        }
        




     renderCheckBox = (cell, row, enumObject, rowIndex) => {
        //debugger;
        let checkBox=<input className="checkbox form-check-input" type="checkbox" value={row.product_id} onChange={(e) => {
                     this.checkBoxChangeUpdate(row,e,rowIndex)
                }} checked={row.checked}/>
        
        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">
                  {checkBox}
            </div>
        </div>)
    }


    

    render() {
        const options = {
            page: 1,  // which page you want to show as default
            sizePerPage: 10,  // which size per page you want to locate as default
        }
        return (
            <div style={{  backgroundColor: "#e1e5ed",margin: "0% 4%"  }}>
                <Dialog ref={el => this.dialog = el} />
                <BootstrapTable
                    className="table-border"
                    options={options}
                    data={this.props.row.store_kits}
                    hover={false}
                    headerStyle={{ border: '0px', color: '#000' }}
                    tableStyle={{ border: '0px' }}
                    bodyStyle={{ border: '0px', overflow: "auto" }}>

                    <TableHeaderColumn
                        dataField="store_kit_id"
                        width="1"
                        isKey={true}
                        hidden={true}
                        expandable={false}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Id
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="store_name"
                        className="table-header"
                        width="50"
                        columnClassName="table-body"
                        dataSort={true}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209"}}>                   
                        Store
                    </TableHeaderColumn>                    
                   
                    <TableHeaderColumn
                        dataFormat={this.renderCheckBox}
                        className="table-header"
                        dataAlign='center'
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209"}}
                        width="10"
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Actions
                    </TableHeaderColumn>
                </BootstrapTable>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        products_stocks: state.products_stocks
    }
}

export default connect(mapStateToProps)(withRouter(CollapsibleRow))


// WEBPACK FOOTER //
// ./src/modules/ProductsStocks/Components/CollapsibleRow.js